import { render, staticRenderFns } from "./CoCourseware.vue?vue&type=template&id=18c126dc&scoped=true&"
import script from "./CoCourseware.vue?vue&type=script&lang=js&"
export * from "./CoCourseware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c126dc",
  null
  
)

export default component.exports